import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoggedAs = () => {
  const { isAuthenticated, user } = useAuth0();
  if ( !isAuthenticated ) {
    return <></>;
  }

  return (
    <div className="nav-item p-1">({user.name})</div>
  );
};

export default LoggedAs;
